
import stilogo from "./sti-logo.png"
import socalgaslogo from "./SoCalGas_logo.webp"
import React, { useState, useRef } from 'react';
import { SendAlertsModal } from "./SendAlertsModal";

import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { CSVLink } from 'react-csv';
import { useNavigate } from "react-router-dom";
// setup the ref that we'll use for the hidden CsvLink click once we've updated the data


import awsExports from './aws-exports';
import { subscriberreport } from "./api";
Amplify.configure(awsExports);



export default function AdminScreen() {

  const csvLinkRef = useRef();
  let [showSendAlerts, setSendAlerts] = useState(false);
  let [fileData, setFileData] = useState([]);
  let navigate = useNavigate();


  const gotoalertshistory = () => {
    let path = `../alertshistory`;
    navigate(path, { state: { showSubscribers: true } });
  }

  const gotohomescreen = () => {
    let path = `../manage`;
    navigate(path);
  }

  const exportSubscribers = async () => {
    try {
      setFileData(await subscriberreport());
    } catch (e) {
      console.error("really oh noes", e)
    }
    csvLinkRef?.current?.link.click();
  }


  return (
    <Authenticator loginMechanisms={['username']} hideSignUp={true} >
      {({ signOut, user }) => (
        <main>
          <button style={{ float: 'right' }} className={"btn btn-link locale-link"} onClick={signOut}>Sign out</button>
          <button style={{ float: 'left' }} className={"btn btn-link locale-link"} onClick={gotohomescreen}>Home</button>

          <div className="App">


            <div className="px-4 py-5 my-5 text-center">

              <h2 className="display-7 fw-bold">
                Administrator for the Aliso Canyon Fence-Line Monitoring System
              </h2>
              <p className="lead mb-4">
                Click on the Appropriate Button Below.
              </p>
              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button type="button" className="btn btn-primary btn-lg px-4 gap-3"
                  onClick={() => setSendAlerts(true)}
                >
                  Manage Incidents
                </button>

                <button type="button" className="btn btn-primary btn-lg px-4 gap-3"
                  onClick={exportSubscribers}
                >
                  Export Subscribers  </button>
                <CSVLink
                  data={fileData}
                  className="exportButton"
                  filename="file.csv"
                  ref={csvLinkRef}
                >
                </CSVLink>

                <button type="button" className="btn btn-primary btn-lg px-4 gap-3"
                  onClick={gotoalertshistory}
                >
                  View Alert History
                </button>
              </div>
            </div>



            <div className={"text-center"} style={{ marginBottom: '20px' }}>
              Operated by<br />
              <img src={stilogo} alt={"Sonoma Technology, Inc."} style={{ height: '32px' }} />
            </div>
            <div id={"featured-3"} className={"px-4 py-5"} style={{ backgroundColor: "lightgray" }}>

              <div className="col-lg-6 mx-auto">
                <p>
                  SoCalGas is providing the opportunity to receive an email or text message with a warning
                  when the fence-line monitoring system at the Aliso Canyon Gas Storage Facility detects methane
                  in the air in excess of 25 parts per million for 30 minutes,
                  followed by a detection of benzene at a level of 1.5 parts per billion or greater averaged over any 30-minute period.
                  The warning does not necessarily mean that you have been exposed to benzene from the facility.
                  Distance from the facility, wind direction, meteorological conditions, and topography
                  all play a part in whether there would be concentrations of benzene high enough to cause an exposure at a specific location.
                  If a warning notification is issued, you are encouraged to check the <a href={"../warnings"}>alisocynalerts.sonomatechdata.com/warnings</a> for more information on the nature and timing of the exceedance.
                  These warning notifications are provided pursuant to California’s Proposition 65
                  and are similar to warning notifications you may be familiar with at gas stations,
                  parking garages and other locations. For questions about California’s Proposition 65,
                  please visit <a href={"https://www.p65warnings.ca.gov/"}>p65warnings.ca.gov</a>
                </p>


                <p style={{ fontSize: "small", marginTop: "40px" }}>
                  Sonoma Technology, Inc. is a SoCalGas authorized contractor responsible for administering this program.
                </p>

                <p style={{ fontSize: "small" }}>
                  Reference herein to any specific information regarding Southern California Gas Company (SoCalGas®) or any commercial products or services by trade name, trademark, manufacturer or otherwise, does not constitute or imply its endorsement, recommendation or favoring by SoCalGas. SoCalGas will not be held liable in connection with any of Sonoma Technology, Inc.’s activities. Without limiting the generality of the foregoing, SoCalGas and do not represent or warrant the accuracy or reliability of any of the information, content or advertisements contained on, distributed through, or linked, downloaded or accessed from this website other than the information contained on each of their respective websites.
                </p>

                <p style={{ fontSize: "small" }}>
                  While this website is operated by Sonoma Technology, Inc., we follow the Terms & Conditions and Privacy Policy of SoCalGas.
                  For the Terms & Conditions and Privacy Policy that govern this website, please visit the SoCalGas website at <a href={"https://www.socalgas.com"}>www.socalgas.com</a>.
                </p>

                <p style={{ fontSize: "small" }}>
                  ©2022 Sonoma Technology, Inc. The trademarks used herein are the property of their respective owners. All rights reserved. Some materials used under license, with all rights reserved by licensor.
                </p>

                <div className={"text-center"}>
                  <img src={stilogo} alt={"Sonoma Technology, Inc."} style={{ height: '64px' }} />
                </div>

                <div className={"text-center"} style={{ marginTop: '20px' }}>
                  <img src={socalgaslogo} alt={"SoCalGas"} style={{ height: '64px' }} />
                </div>

              </div>

            </div>


          </div>
          <SendAlertsModal showModal={showSendAlerts} onClose={() => setSendAlerts(false)} />

          }
        </main>
      )}

    </Authenticator>
  );
}

